import * as React from 'react';
import OrderCard from './OrderCard';

export enum LoadStatus {
  Processing,
  Success,
  NotFound,
  Error
}

export enum OS {
  Ios,
  Android,
  Desktop
}

interface AppProps {
  lang: string;
  onLangChange: (lang: string) => void;
}
interface AppState {
  order: models.Order | undefined;
  loadStatus: LoadStatus;
}

class App extends React.Component<AppProps, AppState> {

  private socket: WebSocket | undefined;
  private orderId: string | undefined;

  constructor(props: AppProps) {
    super(props);
    this.state = {
      order: undefined,
      loadStatus: LoadStatus.Processing
    };
  }

  componentDidMount() {

    let index = location.pathname.lastIndexOf('/');
    if (index >= 0) {
      this.orderId = location.pathname.slice(index + 1);
    }
    if (this.orderId) {
      let promise = fetch('/api/v2/shared/order/' + this.orderId);
      promise.then(
        (response) => {
          if (response.status === 500) {
            this.setState({
              loadStatus: LoadStatus.Error
            });
          } else {
            response.json().then((res) => {
              if (res.ok) {
                if (typeof WebSocket === 'function' && this.orderId) {
                  this.socketConnect();
                }
                this.setState({
                  order: res.data,
                  loadStatus: LoadStatus.Success
                });
              } else {
                this.setState({
                  loadStatus: LoadStatus.NotFound
                });
              }
            });
          }
        },
        (error) => {
          this.setState({
            loadStatus: LoadStatus.Error
          });
        });
    } else {
      this.setState({
        loadStatus: LoadStatus.Error
      });
    }
  }

  componentWillUnmount() {

    if (this.socket) {
      this.socket.close();
      this.socket = undefined;
    }
  }

  render() {

    let style = {
      background: '#FAFAFA',
      margin: 'auto',
      height: '100%',
      display: 'flex',
      flexDirection: 'column' as 'column',
      position: 'relative' as 'relative'
    };

    return (
      <div style={style}>
        <OrderCard 
          style={{ flex: '1 1 100%' }}
          loadStatus={this.state.loadStatus}
          order={this.state.order}
          lang={this.props.lang}
          onLangChange={this.props.onLangChange}
          os={this.getOS()}
        />
      </div>
    );
  }

  public getOS(): OS {
    
    let userAgent = window.navigator.userAgent,
        platform = window.navigator.platform,
        iosPlatforms = ['iPhone', 'iPad', 'iPod'];
  
    if (iosPlatforms.indexOf(platform) !== -1) {
      return OS.Ios;
    } else if (/Android/.test(userAgent)) {
      return OS.Android;
    }
  
    return OS.Desktop;
  }

  private socketConnect() {

    let wsFlag = location.host.slice(0, 9) === 'localhost' || location.host.slice(0, 9) === '127.0.0.1';
    let url: string;
    if (wsFlag) {
      url = 'ws://127.0.0.1:5000';
    } else {
      url = 'wss://' + location.host;
    }
    url += '/api/v2/shared/ws?id=' + this.orderId;
    this.socket = new WebSocket(url);
    // Listen for messages
    this.socket.addEventListener('message', (event) => {
      this.setState({
        order: JSON.parse(event.data),
        loadStatus: LoadStatus.Success
      });
    });
    this.socket.addEventListener('close', (event) => {
      setTimeout(this.socketConnect, 3000);
    });
  }
}

export default App;


// WEBPACK FOOTER //
// /opt/build/sharedorder/node_modules/tslint-loader!./src/components/App.tsx